// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"e0faabfe","450":"2de5fc57","891":"9ca65673"}[chunkId] + ".chunk.js";
};